<div class="page-title-area item-bg1 jarallax" data-jarallax='{"speed": 0.3}'>
  <div class="container">
    <div class="page-title-content">
      <ul>
        <li><a routerLink="/">Главная</a></li>
        <li>Курсы</li>
      </ul>
      <h2>Список курсов</h2>
    </div>
  </div>
</div>

<section class="courses-area ptb-100">
  <div class="container">
    <div class="courses-topbar">
      <div class="row align-items-center">
        <div class="col-lg-4 col-md-4">
          <div class="topbar-result-count">
            <p>Showing 1 – 6 of 54</p>
          </div>
        </div>

        <div class="col-lg-8 col-md-8">
          <div class="topbar-ordering-and-search">
            <div class="row align-items-center">
              <div class="col-lg-3 col-md-5 offset-lg-4 offset-md-1">
                <div class="topbar-ordering">
                  <select>
                    <option>Sort by popularity</option>
                    <option>Sort by latest</option>
                    <option>Default sorting</option>
                    <option>Sort by rating</option>
                    <option>Sort by new</option>
                  </select>
                </div>
              </div>

              <div class="col-lg-5 col-md-6">
                <div class="topbar-search">
                  <form>
                    <label><i class="bx bx-search"></i></label>
                    <input class="input-search" placeholder="Поиск" type="text">
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div *ngFor="let course of courses" class="col-lg-4 col-md-4">
        <div class="single-courses-box mb-30">
          <div class="courses-image">
            <a class="d-block" routerLink="{{'/course-details/'+course._id}}">
              <img alt="image" src="{{course.imgUrl || 'assets/img/courses/courses1.jpg'}}"></a>
            <div class="courses-tag">
              <a class="d-block">{{course.category}}</a>
            </div>
          </div>

          <div class="courses-content">
            <div class="course-author d-flex align-items-center">
              <img alt="image" class="rounded-circle mr-2" src="{{course.instructor.imgUrl || 'assets/img/user1.jpg'}}">
              <span>{{course.instructor.fullName}}</span>
            </div>
            <h3><a class="d-inline-block" routerLink="{{'/course-details/'+course._id}}">{{course.title}}</a></h3>
            <div class="courses-rating">
              <div class="review-stars-rated">
                <i class='bx bxs-star'></i>
                <i class='bx bxs-star'></i>
                <i class='bx bxs-star'></i>
                <i class='bx bxs-star'></i>
                <i class='bx bxs-star'></i>
              </div>
              <div class="rating-total">
                (5.0)
              </div>
            </div>
          </div>

          <div class="courses-box-footer">
            <ul>
              <li class="students-number">
                <i class='bx bx-user'></i> {{course.enrolled}} Студенты
              </li>
              <li class="courses-lesson">
                <i class='bx bx-book-open'></i> {{course.chapters.length}} Уроки
              </li>
              <li class="courses-price">
                {{course.price}} сом
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="pagination-area text-center">
          <span aria-current="page" class="page-numbers current">1</span>
          <a class="page-numbers">2</a>
          <a class="page-numbers">3</a>
          <a class="page-numbers">4</a>
          <a class="page-numbers">5</a>
          <a class="next page-numbers"><i class='bx bx-chevron-right'></i></a>
        </div>
      </div>
    </div>
  </div>
</section>
